import { defineStore } from 'pinia'

export const useGlobalStore = defineStore("global", {
  state: () => ({
    user: null,
    isAuthenticated: false,
    theme: "light",
    denoncoSelect: [
      "Këshilli Prokurorial i Kosovës",
      "Zyra e Kryeprokurorit të Shtetit",
      "Prokuroria Speciale",
      "Prokuroria themelore Prishtinë",
      "Prokuroria themelore Gjilan",
      "Prokuroria themelore Mitrovicë",
      "Prokuroria themelore Prizren",
      "Prokuroria themelore Pejë",
      "Prokuroria themelore Gjakovë",
      "Prokuroria themelore Ferizaj",
    ],
    loading: false,
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
      this.isAuthenticated = true;
    },
    logout() {
      this.user = null;
      this.isAuthenticated = false;
    },
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
    },
  },
  getters: {
    isLoggedIn: (state) => state.isAuthenticated,
    getDenoncoSelect: (state) => state.denoncoSelect,
  },
});
